import CameraRenderPreview from "./CameraRenderPreview";

/** Contents of the hover popover above a camera marker on the 3D map: just the render. */
export default function CameraHoverPreview(props: { cameraId: string; name: string }) {
  const { cameraId, name } = props;

  return (
    <div
      className="w-[236px]"
      role="img"
      aria-label={name}
      data-testid="camera-hover-preview"
    >
      {/* compact: the "no preview" state shows its icon only, like the rest of the popover */}
      <CameraRenderPreview cameraId={cameraId} compact />
    </div>
  );
}
